import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { setUserOptions } from '../redux/builderStore';
import { useAppDispatch, useAppSelector, RootState } from '../redux/builderStoreHooks';
import { DEFAULT_APP_OPTIONS } from './UserOptionsSubMenu';
import { generateUserKey } from '../utils/storage';

import '@esri/calcite-components/dist/components/calcite-label';
import '@esri/calcite-components/dist/components/calcite-icon';
import '@esri/calcite-components/dist/components/calcite-switch';
import { CalciteLabel, CalciteIcon, CalciteSwitch } from '@esri/calcite-components-react';

const DEFAULT_OPTIONS = [DEFAULT_APP_OPTIONS];

const DARK_THEME = 'calcite-mode-dark',
    LIGHT_THEME = 'calcite-mode-light',
    THEME_KEY = 'uitheme';

const DarkModeSwitch = ({ showInterface = true }) => {
    const userOptions: any = useAppSelector((state: RootState) => state.userOptions) ?? {},
        user: any = useAppSelector((state: RootState) => state.appSettings.user) ?? {},
        userKey = generateUserKey(user),
        dispatch = useAppDispatch(),
        appOptions =
            userOptions.find((o: any) => o.id === 'application' && o.user === userKey) ??
            DEFAULT_APP_OPTIONS;
    const browserPrefersDark =
        window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    const fallbackThemeKey = browserPrefersDark ? DARK_THEME : LIGHT_THEME;
    const theme =
        appOptions !== undefined && appOptions[THEME_KEY] !== null
            ? appOptions[THEME_KEY] ?? fallbackThemeKey
            : fallbackThemeKey;

    const setUserOption = (key: string, v: any) => {
        if (userKey === '') {
            return;
        }
        const hasOptions =
                userOptions !== undefined
                    ? userOptions.findIndex(
                          (o: any) => o.id === 'application' && o.user === userKey
                      )
                    : -1,
            defaultOptions = DEFAULT_OPTIONS.find((o) => o.id === 'application') ?? {},
            activeOptions =
                hasOptions >= 0
                    ? {
                          ...defaultOptions,
                          ...userOptions.find((o: any) => o.id === 'application'),
                          user: userKey
                      }
                    : { ...defaultOptions, user: userKey };
        if (key !== undefined && key !== null) {
            const cloneOptions = [...userOptions];
            if (activeOptions[key] !== undefined) {
                if (v !== undefined && v !== null) {
                    activeOptions[key] = v;
                }
                if (hasOptions < 0) {
                    cloneOptions.push(activeOptions);
                } else {
                    cloneOptions.splice(hasOptions, 1, activeOptions);
                }
            }
            dispatch(setUserOptions(cloneOptions));
        }
    };

    useEffect(() => {
        const calciteRootElement =
            document.querySelector('calcite-shell') ?? document.documentElement;
        calciteRootElement.classList.replace(DARK_THEME, theme);
        calciteRootElement.classList.replace(LIGHT_THEME, theme);
        if (!calciteRootElement.classList.contains(theme)) {
            calciteRootElement.classList.add(theme);
        }
        setUserOption(THEME_KEY, theme);
    }, [theme]);

    return showInterface ? (
        <ul className="inline-list">
            <li>
                <CalciteLabel layout="inline" className="label-wrapper">
                    <CalciteIcon icon="brightness" scale="s" class="switch-icon"></CalciteIcon>
                    <CalciteSwitch
                        checked={theme === DARK_THEME ? true : undefined}
                        onCalciteSwitchChange={(evt) => {
                            const isChecked = evt.target.checked;
                            setUserOption(THEME_KEY, isChecked ? DARK_THEME : LIGHT_THEME);
                        }}
                    ></CalciteSwitch>
                    <CalciteIcon icon="moon" scale="s" class="switch-icon"></CalciteIcon>
                </CalciteLabel>
            </li>
        </ul>
    ) : (
        <></>
    );
};

export default DarkModeSwitch;
